import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
import { OrderCdekDeliveryTimes } from './OrderCdekDeliveryTimes'
import { CdekCourierSlotStatus } from './Enums'
/**
* Class OrderDeliveryMethodCdekCourierDto
*  Специфика доставки СДЭК курьером (адрес до двери, без ПВЗ).
*/
export class OrderDeliveryMethodCdekCourierDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'CdekCourier' })
  readonly kind: string = 'CdekCourier'


  /**
  * to
  * Адрес доставки (без Domain.Entities.Cdek.CdekLocation.OfficeCode).  */
  @ActiveField({
    factory: [CdekLocation, () => undefined]
  })
  to?: CdekLocation


  /**
  * times
  * Сроки доставки (калькулятор + Extra*).  */
  @ActiveField({
    factory: [OrderCdekDeliveryTimes, () => undefined]
  })
  times?: OrderCdekDeliveryTimes


  /**
  * cdekOrderNumber
  * Номер заказа в CDEK.  */
  @ActiveField()
  cdekOrderNumber?: null | number


/**
  * slotDate
  * Дата выбранного интервала доставки (календарная дата СДЭК)
  */
  @ActiveField()
  slotDate?: null | string


/**
  * slotTimeFrom
  * Начало интервала (`HH:mm`, как в ответе СДЭК)
  */
  @ActiveField()
  slotTimeFrom?: null | string


/**
  * slotTimeTo
  * Конец интервала (`HH:mm`, как в ответе СДЭК)
  */
  @ActiveField()
  slotTimeTo?: null | string


  /**
  * slotStatus
  * словарь значений публикуется под именем `Domain.Entities.Orders.CdekCourierSlotStatus`  *   * Статус брони интервала  *   * - `None` Не выбран  *   * Слот не выбирали или список окон был пуст  * - `Pending` Ожидает брони  *   * Окно выбрано на checkout, бронь в СДЭК ещё не создана  * - `Confirmed` Подтверждён  *   * Договорённость подтверждена (appointment или webhook)  * - `Unconfirmed` Не подтверждён  *   * Окно выбрано, СДЭК не принял бронь после исчерпания retry  *   */
  @ActiveField()
  slotStatus?: CdekCourierSlotStatus


/**
  * deliveryAgreementUuid
  * Uuid договорённости СДЭК (`delivery/appointment` или webhook), если есть
  */
  @ActiveField()
  deliveryAgreementUuid?: null | string
}
